import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$b = ".LastUsed_module_container__4e54ed99{position:relative}.LastUsed_module_badge__4e54ed99{position:absolute;right:var(--st-spacing-3);top:0;translate:0 -60%}[dir=rtl] .LastUsed_module_badge__4e54ed99{left:var(--st-spacing-3);right:auto}.LastUsed_module_badge__4e54ed99:dir(rtl){left:var(--st-spacing-3);right:auto}";
collectCss(css$b);
var modules_9331f432 = {"container":"LastUsed_module_container__4e54ed99","badge":"LastUsed_module_badge__4e54ed99"};

export { css$b as css, modules_9331f432 as default };
//# sourceMappingURL=LastUsed.module.css.mjs.map
